import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { Content } from './content.jsx';
import { Footer } from './footer.jsx';
import { useProducer, useStore } from './store/hooks.js';
import { Panel as _Panel } from '#~/common/editor/index.js';

/** Settings `<Panel>` component. */
export const Panel = (props: HtmlAttributes): ReactElement => {
  const producer = useProducer();

  const name = useStore(({ candidate }) => candidate.name);

  useEffect(() => {
    // All we need is a name to continue.
    producer((draft) => {
      draft.isReady = !!name;
    });
  }, [name]);

  return (
    <_Panel {...props}>
      <Content />
      <Footer />
    </_Panel>
  );
};
